import { Pipe, PipeTransform, Sanitizer } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(protected sanitizer: DomSanitizer) { }
  transform(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

}